<template>
  <div style="width: 700px;">
    <h3 style="margin-bottom: 20px;"># 圈子信息</h3>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
      <div>
        <div class="CoverLogo">
          <el-form-item label="圈子名称" prop="name">
            <el-input v-model="ruleForm.name" style="width: 205px;" placeholder="请输入圈子名称"></el-input>
          </el-form-item>
          <el-form-item label="圈子所属广场" prop="squareId">
            <el-select v-model="ruleForm.squareId" placeholder="请选择">
              <el-option v-for="(item, index) in squareList" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 圈子图标 -->
        <div class="CoverLogo">
          <el-form-item label="圈子logo" prop="coverLogo" style="margin-right: 10px;">
            <el-upload class="avatar-uploader" :action="url" :headers="{ 'token': token }" :show-file-list="false"
              :on-success="handleCoverSuccess">
              <img v-if="ruleForm.coverLogo" :src="ruleForm.coverLogo" style="width: 100px;object-fit: cover;height: 100px">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </el-form-item>
          <!-- 圈子背景图 -->
          <el-form-item label="圈子背景图" prop="backgroundLogo">
            <el-upload class="avatar-uploader" :action="url" :headers="{ 'token': token }" :show-file-list="false"
              :on-success="handlebackgroundSuccess">
              <img v-if="ruleForm.backgroundLogo" :src="ruleForm.backgroundLogo" style="width: 100px;height: 100px;object-fit: cover;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item label="是否置顶" prop="topState">
          <el-select v-model="ruleForm.topState" placeholder="请选择">
            <el-option label="不置顶" :value="0"></el-option>
            <el-option label="置顶" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="圈子状态" prop="">
          <el-select v-model="ruleForm.circleState" placeholder="请选择">
            <el-option label="正常访问" :value="0"></el-option>
            <el-option label="暂停访问" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="圈子简介" prop="circleDescribe">
          <el-input type="textarea" v-model="ruleForm.circleDescribe"></el-input>
        </el-form-item>
        <el-form-item label="管理团队权益与规范" prop="circleAdminDesc">
          <el-input type="textarea" v-model="ruleForm.circleAdminDesc" placeholder="请输入..."></el-input>
        </el-form-item>
        <el-form-item label="管理员申请">
          <el-switch v-model="ruleForm.authCircleSwitch" active-text="允许" inactive-text="关闭"></el-switch>
          <div class="field-tip">还需“圈子设置”中的平台管理员申请总开关开启后才会生效</div>
        </el-form-item>
        <el-form-item label="圈主申请">
          <el-switch v-model="ruleForm.circleaPplySwitch" active-text="允许" inactive-text="关闭"></el-switch>
          <div class="field-tip">还需“圈子设置”中的平台圈主申请总开关开启后才会生效</div>
        </el-form-item>
        <el-form-item label="二维码展示" prop="">
          <el-select v-model="ruleForm.chatQrcodeState" placeholder="请选择">
            <el-option label="开启" :value="1"></el-option>
            <el-option label="关闭" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="ruleForm.chatQrcodeState" label="二维码展示字样" prop="chatQrcodeDescribe">
          <el-input type="text" v-model="ruleForm.chatQrcodeDescribe" placeholder="请输入..."></el-input>
        </el-form-item>
        <el-form-item v-show="ruleForm.chatQrcodeState" label="群聊二维码" prop="">
          <el-upload class="avatar-uploader" :action="url" :headers="{ 'token': token }" :show-file-list="false"
            :on-success="handleCodeSuccess">
            <img v-if="ruleForm.chatQrcode" :src="ruleForm.chatQrcode" style="width: 100px;object-fit: cover;height: 100px;">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="发帖等级" prop="releaseGrade">
          <el-input v-model="ruleForm.releaseGrade" placeholder="0为不限制"></el-input>
        </el-form-item>
        <el-form-item label="访问等级" prop="browseGrade">
          <el-input v-model="ruleForm.browseGrade" placeholder="0为不限制"></el-input>
        </el-form-item>
        <el-form-item label="发帖次数" prop="limitPostingNumber">
          <el-input v-model="ruleForm.limitPostingNumber" placeholder="0为不限制"></el-input>
        </el-form-item>
        <el-form-item label="虚拟关注数" prop="virtualFollow">
          <el-input v-model="ruleForm.virtualFollow" placeholder="请输入..."></el-input>
        </el-form-item>
        <el-form-item label="虚拟帖子数" prop="virtualPostingNumber">
          <el-input v-model="ruleForm.virtualPostingNumber" placeholder="请输入..."></el-input>
        </el-form-item>
        <el-form-item label="浏览权限" prop="">
          <el-radio-group v-model="ruleForm.browsePermissions">
            <el-radio :label="0">所有用户可见</el-radio>
            <el-radio :label="1">会员用户可见</el-radio>
            <el-radio :label="2">审核加入可见</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="暗号开关" v-show="ruleForm.browsePermissions === 2 ? true : false" prop="">
          <el-select v-model="ruleForm.secretState" placeholder="请选择">
            <el-option label="开启" :value="1"></el-option>
            <el-option label="关闭" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="暗号信息" prop="" v-show="ruleForm.secretState">
          <el-input v-model="ruleForm.secretContent"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="ruleForm.sort" placeholder="可为空 顺序的时候越小越靠前 倒序同理"></el-input>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">
          {{ this.circleId ? '更新' : '创建' }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { AddCircleApi, loadSquareList, circleDetailApi } from '@/api/user'
import { getToken } from "@/utils/lostorage";
import { uploadFileUrl } from "@/api/common";
import { Message } from "element-ui";
export default {
  name: 'newCircle',
  computed: {
    fileList() {
      return [{ url: this.$store.state.COSdata + '/circle/CoverLogo/defaultLogo.jpeg' }]
    },
    fileListTwo() {
      return [{ url: this.$store.state.COSdata + '/circle/CoverPhoto/defaultBGCLogo.gif' }]
    },
    token() {
      return getToken()
    },
    url() {
      return uploadFileUrl;
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      squareList: [],
      circleId: '',
      // 图片
      typeNum: 1,
      ruleForm: {
        circleId: '',
        name: '',
        squareId: '',
        coverLogo: '',
        backgroundLogo: '',
        topState: 0,
        circleDescribe: '这个圈主很懒~什么都没有留下',
        chatQrcode: '',
        chatQrcodeDescribe: '',
        chatQrcodeState: '',
        authCircleSwitch: true,
        circleaPplySwitch: true,
        browsePermissions: 0,
        secretState: '',
        secretContent: '',
        releaseGrade: 0,
        browseGrade: 0,
        limitPostingNumber: 0,
        virtualPostingNumber: 0,
        virtualFollow: 0,
        circleState: 0,
        sort: '',
        createTime: ''
      },
      rules: {
        name: [{ required: true, message: '请输入圈子名称', trigger: 'blur' }],
        coverLogo: [{ required: true, message: '请上传圈子logo', trigger: 'blur' }],
        squareId: [{ required: true, message: '请选择对应广场', trigger: 'blur' }],
        topState: [{ required: true, message: '请选择置顶状态', trigger: 'blur' }],
        circleDescribe: [{ required: true, message: '请输入圈子简介', trigger: 'blur' }],
        browsePermissions: [{ required: true, message: '请输入访问等级', trigger: 'blur' }],
        Browse_permissions: [{ required: true, message: '请选择广场权限', trigger: 'blur' }],
        releaseGrade: [{ required: true, message: '请输入发帖等级', trigger: 'blur' }],
        limitPostingNumber: [{ required: true, message: '请输入发帖次数, 0为不限制', trigger: 'blur' }],
        virtualFollow: [{ required: true, message: '请输入虚拟关注数量', trigger: 'blur' }],
        virtualPostingNumber: [{ required: true, message: '请输入虚拟帖子数量', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.circleId = this.$route.query.id
    if (this.circleId) {
      this.getDetail()
    }
    this.getSquareList()
  },
  methods: {
    getDetail() {
      circleDetailApi(this.circleId).then(res => {
        if (res.code == 200) {
          const detail = res.data || {}
          this.ruleForm = {
            ...this.ruleForm,
            ...detail,
            authCircleSwitch: detail.authCircleSwitch !== false,
            circleaPplySwitch: detail.circleaPplySwitch !== false
          }
        } else {
          this.$message.error(res.msg || '获取圈子详情失败')
        }
      }).catch(err => this.$message.error(err || '获取圈子详情失败'))
    },
    handlebackgroundSuccess(response) {
      this.ruleForm.backgroundLogo = response?.data.url
      Message.success("上传成功")
    },
    handleCodeSuccess(response) {
      this.ruleForm.chatQrcode = response?.data.url
      Message.success("上传成功")
    },
    handleCoverSuccess(response) {
      this.ruleForm.coverLogo = response?.data.url
      Message.success("上传成功")
    },
    getSquareList() {
      loadSquareList().then(res => {
        if (res.data) {
          this.squareList = res.data
        }
      })
    },
    // 新建圈子提交事件
    async submitForm(formName) {
      const that = this
      that.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.ruleForm.auditStatus = 1
            await AddCircleApi(this.ruleForm)
            this.$message({ message: '创建成功', type: 'success' })
            this.$router.push('/circle')
          } catch {
            this.$message.error('创建失败请重试')
          }
        } else {
          return false
        }
      })
    },

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-upload {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border: 1px dashed #ccc;
  border-radius: 5px;
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

.field-tip {
  margin-top: 5px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.CoverLogo {
  display: flex;
}
</style>
